import React from 'react';
const Select = ({ className, options, selectedOption, setSelectedOption }) => {
    const handleSelectChange = (event) => {
        setSelectedOption(event.target.value);
    };
    return (React.createElement("div", { className: className },
        React.createElement("select", { id: "select-option", value: selectedOption || '', onChange: handleSelectChange }, options && options.map((option) => (React.createElement("option", { key: option.uuid, value: option.uuid }, option.name))))));
};
export default React.memo(Select);
